import dynamic from "next/dynamic";
import React from "react";
import { FrontPagesFooter } from "../components/front-pages/commons";
import FrontPagesLayout from "../components/front-pages/front-pages-layout";
import { CatlogPromise, HowCatlogHelpsYou, WhyCatlogHeader } from "../components/front-pages/why-catlog";
import CatlogCommunity from "../components/front-pages/why-catlog/catlog-community";
import { PageTags } from "../components/seo-tags";
import PagesLoaderContext from "../contexts/page-loader-context";

const ReasonsToUseCatlog = dynamic(() => import("../components/front-pages/why-catlog/reasons-to-use-catlog"), {
  ssr: true,
});

const pageTags: PageTags = {
  title: "Catlog - Why Catlog",
  description:
    "Catlog understands that your business has endless possibilities on social media - and we want to help you harness that, here's a number of reasons to use catlog",
  pageUrl: "/why-catlog",
  image: "https://res.cloudinary.com/catlog/image/upload/v1671181798/seo-banners/Main_Banner.png",
};

const HomePage = () => {
  return (
    <PagesLoaderContext.Provider>
      <FrontPagesLayout tags={pageTags}>
        <main>
          <WhyCatlogHeader />
          <HowCatlogHelpsYou />
          <ReasonsToUseCatlog />
          <CatlogPromise />
          <CatlogCommunity />
          <FrontPagesFooter />
        </main>
      </FrontPagesLayout>
    </PagesLoaderContext.Provider>
  );
};

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}

export default HomePage;
